import React from 'react';
import { DriverVerification } from '../components/verification/DriverVerification';

const DriverVerificationPage = () => {
  return <DriverVerification />;
};

export default DriverVerificationPage;
